import type { Store } from '../domain/types';

// DE: Unterstützte Märkte in Deutschland. Das Preisniveau ist eine grobe Schätzung als Startwert.
// EN: Supported stores in Germany. The price level is a rough estimate used as a starting point.
export const STORES: readonly Store[] = [
  {
    id: 'aldi',
    name: 'Aldi',
    color: '#00539f',
    offersUrl: 'https://www.aldi-sued.de/',
    priceFactor: 1,
  },
  {
    id: 'kaufland',
    name: 'Kaufland',
    color: '#e10915',
    offersUrl: 'https://www.kaufland.de/angebote/aktuelle-woche.html',
    priceFactor: 0.98,
  },
  { id: 'lidl', name: 'Lidl', color: '#0050aa', offersUrl: 'https://www.lidl.de/', priceFactor: 1 },
  {
    id: 'penny',
    name: 'Penny',
    color: '#cd1414',
    offersUrl: 'https://www.penny.de/angebote',
    priceFactor: 1.02,
  },
  {
    id: 'netto',
    name: 'Netto',
    color: '#f7d117',
    offersUrl: 'https://www.netto-online.de/',
    priceFactor: 1.02,
  },
  {
    id: 'rewe',
    name: 'Rewe',
    color: '#cc071e',
    offersUrl: 'https://www.rewe.de/angebote/',
    priceFactor: 1.12,
  },
];
